import { Button } from "@/components/ui/button"
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from "@/components/ui/dialog"
import { useRef } from "react"; // Import useRef

// Removed unused imports: Input, Label

export function ConfirmationDialog({
	title = "Confirm Before Procceding",
	message = "Anyone who has this link will be able to view this.",
	onConfirm = () => { },
	onDismiss = () => { },
	trigger = null,
	open = false,
	onOpenChange = () => { } // This callback is crucial for programmatic dismissal
}) {
	const closeButtonRef = useRef(null); // Create a ref for the close button

	/**
	 * A function to programmatically dismiss (close) the dialog.
	 * This is achieved by calling the onOpenChange prop with `false`.
	 */
	const dismissDialog = () => {
		// Trigger a click on the close button to dismiss the dialog
		if (closeButtonRef.current) {
			closeButtonRef.current.click();
		}
	};

	return (
		<Dialog {...(trigger === null ? { open, onOpenChange } : {})}>
			{trigger && <DialogTrigger asChild>
				{trigger}
			</DialogTrigger>}
			<DialogContent className="sm:max-w-md">
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
					<DialogDescription>
						{message}
					</DialogDescription>
				</DialogHeader>
				<DialogFooter className="sm:justify-start gap-2">
					<DialogClose asChild>
						{/* The DialogClose component handles closing the dialog.
							We also call the user's onDismiss callback when this button is clicked. */}
						<Button ref={closeButtonRef} onClick={() => onDismiss()} type="button" variant="soft">
							Close
						</Button>
					</DialogClose>
					{/* When the Confirm button is clicked, we call the onConfirm prop,
						passing it the dismissDialog function. This allows the consumer
						of ConfirmationDialog to programmatically close the dialog
						from within their onConfirm handler. */}
					<Button type="button" variant="success" onClick={() => onConfirm(dismissDialog)}>
						Confirm
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
export default ConfirmationDialog;